export interface FATranslations {
  readonly moreInfoButtonLabel: string;
  readonly configureButtonLabel: string;
}

export type recallType = 'SAFETY' | 'OTHER';

export enum RecallStatus {
  REPAIR_NEEDED = "Repair Needed",
  REPAIR_NOT_YET_AVAILABLE = "Repair Not Yet Available",
  RECALL_COMPLETE = "Recall Complete",
  UNKNOW_STATUS = "Unknow status"
}

export interface RecallsAppModel {
  vin: string;
  status: boolean;
  year: number;
  make: string;
  model: string;
  manufacturerId: number;
  errorCode?: number;
  isRecallsAvailable: boolean;
  numberOfRecalls: number;
  refreshDate: string;
  recalls?: Recall[];
  serviceRecalls?: Recall[];
  safetyRecalls?: Recall[];
  errorMessage?: string;
}


export interface Recall {
  vwgoaActionTitle: string;
  mfrRecallNumber: string;
  nhtsaRecallNumber: string;
  recallDate: string;
  recallDescription: string;
  safetyRiskDescription: string;
  remedyDescription: string;
  mfrRecallStatus: number;
  mfrNotes: string;
  refreshDate: string;
  vwgoaActionType: recallType;
  startDate?: string;
  status?: RecallStatus;
  statusImportant?: boolean;
  title?: string;
}